var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearSkyD(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f59e0b",
    d: "M32 23.36A8.64 8.64 0 1123.36 32 8.66 8.66 0 0132 23.36m0-3A11.64 11.64 0 1043.64 32 11.64 11.64 0 0032 20.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f59e0b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M32 15.71V9.5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    calcMode: "spline",
    dur: "5s",
    keySplines: "0.5 0 0.5 1; 0.5 0 0.5 1",
    keyTimes: "0; .5; 1",
    repeatCount: "indefinite",
    values: "3 6; 6 6; 3 6"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f59e0b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M32 48.29v6.21"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    calcMode: "spline",
    dur: "5s",
    keySplines: "0.5 0 0.5 1; 0.5 0 0.5 1",
    keyTimes: "0; .5; 1",
    repeatCount: "indefinite",
    values: "3 6; 6 6; 3 6"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f59e0b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M43.52 20.48l4.39-4.39"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    calcMode: "spline",
    dur: "5s",
    keySplines: "0.5 0 0.5 1; 0.5 0 0.5 1",
    keyTimes: "0; .5; 1",
    repeatCount: "indefinite",
    values: "3 6; 6 6; 3 6"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f59e0b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M20.48 43.52l-4.39 4.39"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    calcMode: "spline",
    dur: "5s",
    keySplines: "0.5 0 0.5 1; 0.5 0 0.5 1",
    keyTimes: "0; .5; 1",
    repeatCount: "indefinite",
    values: "3 6; 6 6; 3 6"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f59e0b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M20.48 20.48l-4.39-4.39"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    calcMode: "spline",
    dur: "5s",
    keySplines: "0.5 0 0.5 1; 0.5 0 0.5 1",
    keyTimes: "0; .5; 1",
    repeatCount: "indefinite",
    values: "3 6; 6 6; 3 6"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f59e0b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M43.52 43.52l4.39 4.39"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    calcMode: "spline",
    dur: "5s",
    keySplines: "0.5 0 0.5 1; 0.5 0 0.5 1",
    keyTimes: "0; .5; 1",
    repeatCount: "indefinite",
    values: "3 6; 6 6; 3 6"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f59e0b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M15.71 32H9.5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    calcMode: "spline",
    dur: "5s",
    keySplines: "0.5 0 0.5 1; 0.5 0 0.5 1",
    keyTimes: "0; .5; 1",
    repeatCount: "indefinite",
    values: "3 6; 6 6; 3 6"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f59e0b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M48.29 32h6.21"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    calcMode: "spline",
    dur: "5s",
    keySplines: "0.5 0 0.5 1; 0.5 0 0.5 1",
    keyTimes: "0; .5; 1",
    repeatCount: "indefinite",
    values: "3 6; 6 6; 3 6"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "45s",
    from: "0 32 32",
    repeatCount: "indefinite",
    to: "360 32 32",
    type: "rotate"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearSkyD);
export default __webpack_public_path__ + "static/media/clear-sky-d.d3038533.svg";
export { ForwardRef as ReactComponent };